module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0037.jpg?v=8703cc5a";